module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.disabled ? 'disabledOn' : 'disabledOff',
    attrs: {
      "id": "dropdown-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "select-container"
    },
    on: {
      "click": _vm.OnClickStatus
    }
  }, [_c('div', {
    attrs: {
      "id": "placeholder-container"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.captionSelected === "" ? _vm.placeholder : _vm.captionSelected))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "icon-container"
    }
  }, [(_vm.visibleOptions) ? _c('img', {
    attrs: {
      "src": require("../../../assets/img/icons/arrow-up.svg")
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.visibleOptions) ? _c('img', {
    attrs: {
      "src": require("../../../assets/img/icons/arrow-down.svg")
    }
  }) : _vm._e()])]), _vm._v(" "), (!_vm.visibleOptions) ? _c('div', {
    attrs: {
      "id": "option-container"
    }
  }, _vm._l((_vm.arrayRender), function(element) {
    return _c('div', {
      attrs: {
        "id": "option-item"
      },
      on: {
        "click": function($event) {
          return _vm.clickHandlerOptions(element.caption, element.value)
        }
      }
    }, [_c('h2', [_vm._v(_vm._s(element.caption))])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-62a2e20e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/dropdownV2/dropdownV2.vue
// module id = 2149
// module chunks = 1